// Lookup Japanese address from postal code via zipcloud API.
// Replaces jquery-jpostal-ja which caused "require is not defined" in Rollup build.
export function setupZipSearch({ zipInputId, prefectureSelectId, cityInputId }) {
  const zipInput = document.getElementById(zipInputId)
  if (!zipInput) return

  if (zipInput.dataset.zipSearchInit) return
  zipInput.dataset.zipSearchInit = 'true'

  let controller

  zipInput.addEventListener('input', async () => {
    const zip = zipInput.value.replace(/[^\d]/g, '')
    if (zip.length !== 7) return

    controller?.abort()
    controller = new AbortController()

    try {
      const res = await fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zip}`, { signal: controller.signal })
      const data = await res.json()
      if (!data.results) return

      const { address1, address2, address3 } = data.results[0]

      const prefSelect = document.getElementById(prefectureSelectId)
      if (prefSelect) {
        const opt = Array.from(prefSelect.options).find(o => o.text === address1)
        if (opt) {
          prefSelect.value = opt.value
          prefSelect.dispatchEvent(new Event('change', { bubbles: true }))
        }
      }

      const cityInput = document.getElementById(cityInputId)
      if (cityInput) {
        cityInput.value = address2 + address3
        cityInput.dispatchEvent(new Event('input', { bubbles: true }))
      }

      const targets = [prefSelect, cityInput].filter(Boolean)
      targets.forEach(el => el.classList.add('auto-populated'))
      setTimeout(() => targets.forEach(el => el.classList.remove('auto-populated')), 2000)
    } catch (e) {
      if (e.name !== 'AbortError') {
        // silently ignore — user can fill manually
      }
    }
  })
}
